import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill={colorValue}
        fillRule="evenodd"
        d="M12 2.75a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5M7.25 6a4.75 4.75 0 1 1 9.5 0 4.75 4.75 0 0 1-9.5 0M17 14.75a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5M12.25 18a4.75 4.75 0 1 1 9.5 0 4.75 4.75 0 0 1-9.5 0"
        clipRule="evenodd"
      ></path>
      <path
        fill={colorValue}
        fillRule="evenodd"
        d="M18.855 16.573a.75.75 0 0 1 .016 1.06l-1.833 1.89a.75.75 0 0 1-1.115-.043l-.833-1a.75.75 0 0 1 1.152-.96l.3.36 1.252-1.291a.75.75 0 0 1 1.061-.016"
        clipRule="evenodd"
      ></path>
      <path
        fill={colorValue}
        fillRule="evenodd"
        d="M7.422 14.823C6.267 15.483 5.75 16.28 5.75 17s.517 1.517 1.672 2.177c1.134.648 2.751 1.073 4.578 1.073.654 0 1.283-.054 1.874-.155l.252 1.479c-.676.115-1.39.176-2.126.176-2.04 0-3.922-.47-5.322-1.27C5.3 19.692 4.25 18.49 4.25 17s1.05-2.692 2.428-3.48c1.4-.8 3.283-1.27 5.322-1.27 1.81 0 3.493.37 4.825 1.01l-.65 1.352c-1.102-.53-2.558-.862-4.175-.862-1.827 0-3.444.425-4.578 1.073"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};
